import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { datenschutzHtml } from "@/data/datenschutzContent";

export default function DatenschutzPage() {
  return (
    <section className="relative pt-32 pb-24 md:pt-40 md:pb-32 bg-bone-100 min-h-[80vh]">
      <div aria-hidden className="absolute top-32 -left-20 w-[320px] h-[320px] rounded-full bg-sage-200/40 blur-3xl" />

      <div className="relative max-w-3xl mx-auto px-6 lg:px-10">
        <nav className="flex items-center gap-2 font-mono-fine text-[11px] tracking-[0.2em] uppercase text-ink-500 mb-8" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-ink-900 transition-colors">Start</Link>
          <span>›</span>
          <span className="text-sage-600">Datenschutz</span>
        </nav>

        <div className="flex items-center gap-3">
          <span className="w-11 h-11 rounded-full bg-sage-300 text-sage-700 flex items-center justify-center">
            <ShieldCheck strokeWidth={1.75} className="w-4 h-4" />
          </span>
          <span className="font-mono-fine text-[11px] tracking-[0.28em] uppercase text-sage-600">
            Rechtliches
          </span>
        </div>
        <h1 className="mt-4 font-display font-light text-4xl md:text-5xl lg:text-[4rem] leading-[1.02] tracking-[-0.035em] text-ink-900">
          Datenschutz­erklärung
        </h1>
        <p className="mt-6 text-ink-700 leading-relaxed max-w-2xl">
          Der Schutz deiner persönlichen Daten ist mir wichtig. Diese Erklärung informiert dich darüber, welche Daten beim Besuch dieser Website erhoben und wie sie verwendet werden.
        </p>

        <div
          data-testid="datenschutz-content"
          className="legal-content mt-12"
          dangerouslySetInnerHTML={{ __html: datenschutzHtml }}
        />

        <Link
          to="/"
          className="mt-12 inline-flex items-center gap-2 text-[13px] tracking-[0.12em] uppercase font-mono-fine text-ink-900 link-underline"
        >
          <ArrowLeft strokeWidth={1.5} className="w-4 h-4" /> Zurück zur Startseite
        </Link>
      </div>
    </section>
  );
}
